import { Capacitor } from '@capacitor/core'

/** True cuando corremos dentro del contenedor nativo (Capacitor iOS/Android). */
export function isNative(): boolean {
  return Capacitor.isNativePlatform()
}

/**
 * Plataforma del cliente para el header `X-Client-Platform` que el backend usa
 * para emitir el refresh token en el body (ver docs/specs/2026-09-03-auth-refresh-nativo.md).
 * `null` en web → no se manda el header y todo sigue por cookie.
 */
export function clientPlatform(): 'ios' | 'android' | null {
  if (!isNative()) return null
  const platform = Capacitor.getPlatform()
  return platform === 'ios' || platform === 'android' ? platform : null
}
